// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProsSection_wrapper__uTcO_","boxes":"ProsSection_boxes__tDS8F","title":"ProsSection_title__JlgZ4"};